/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import Header from '@/components/header/header'
import styles from './register-agreement.module.scss'
import classNames from 'classnames'
import { getParams } from '@bihu/common-js'
import getHostNameObj from '@/hooks/get-host-name-obj'

interface Props{}
// 注册协议
const RegisterAgreement:React.FC<Props> = props => {
  const hostNameObj = getHostNameObj()

  const [isShowHeader, setIsShowHeader] = useState(false)
  const [name] = useState(hostNameObj.appName)

  useEffect(() => {
    if (getParams(undefined, 'isShowHeader')) {
      setIsShowHeader(true)
    }
  }, [])

  // 卫付通注册协议
  const youqianlaiRegister = () => {
    return (
      <>
        <p>
          本网站产品及服务“卫付通”由深圳市与君融资担保有限公司、厦门乐真网络科技有限公司所有并联合运营（以下简称“我们”或“卫付通”），我们依照以下服务协议向您提供本服务协议涉及的相关服务。请您使用卫付通服务前仔细阅读《用户注册及授权服务协议》（下称“本协议”）以及本平台的其他相关协议、政策或指引。<span className={styles.bold}>所有前述条款和规则构成本协议不可分割的组成部分（以上通称“全部协议”），与本协议正文具有同等法律效力。</span>您只有完全同意全部协议内容，才能成为卫付通的用户（"<span className={styles.bold}>用户</span>"）并使用相应服务。您点击"同意卫付通用户服务协议"按钮即表示您已仔细阅读并明确同意遵守全部协议以及经参引而并入其中的所有条款、政策以及指南，并受该等规则的约束。我们可能根据法律法规的要求或业务运营的需要，对全部协议不时进行修改。除非另有规定，否则任何变更或修改将在修订内容于卫付通发布之时立即生效，您对卫付通的使用、继续使用将表明您接受此等变更或修改。如果您不同意全部协议（包括我们可能不定时对其或其中引述的其他规则所进行的任何修改）的约定，则请勿使用卫付通提供的所有服务，或您可以主动取消卫付通提供的服务。
        </p>
        <div className={styles.emptyLine}></div>
        <p>为了便于您了解适用于您使用卫付通的条款和条件，我们将在卫付通上发布我们对全部协议的修改，请您不时地审阅全部协议以及经参引而并入其中的其他规则。</p>
        <div className={styles.emptyLine}></div>
        <p>
          一、注册账户及用户管理
        </p>
        <div className={styles.emptyLine}></div>
        <p>1、您在使用服务前，应当注册并登录平台。如果您仅需浏览平台，您不需要注册成为我们的用户及提供上述信息。</p>
        <p>2、您有义务在注册时依照平台要求提供自己真实、准确、完整、合法、有效的身份等信息；不得使用他人信息注册、实名认证或向平台提供其他虚假信息。</p>
        <p>3、在注册后，如发现您以虚假信息骗取注册，或您头像、简介等注册信息存在违法和不良信息的，我们有权不经通知单方采取限期改正、暂停使用、注销登记、收回等措施。如因此给平台或其他用户造成损失的，您应当承担相应的责任。</p>
        <p>4、您应及时修改错误信息，更新、完善相关信息。如您未及时修改、更新信息导致平台无法按协议约定向您提供服务，由此产生的后果由您自行承担。</p>
        <p>5、您应当妥善保管自己的账号、密码及其他有效识别信息。您须对使用账户、密码所采取的一切行为负责，因您个人原因导致的账号、密码或其他有效识别信息泄露、丢失或账号和密码被窃取、篡改等导致的一切损失，由您自行承担。</p>
        <p>6、除本协议另有约定，您不应将账号、密码以及账户转让、出售或出借予他人使用。通过您的账户编辑、发布的任何信息或作出的任何行为都将视为您本人的行为。若您授权他人使用账户，应对被授权人在该账户下发生所有行为负全部责任。</p>
        <p>7、在需要终止使用服务时，符合以下条件的，您可以通过人工的方式申请注销您的账户，充分理解且接受以下可能产生的结果：</p>
        <p>（1）您仍应对您在注销账户前且使用服务期间的行为承担相应责任；</p>
        <p>（2）您仅能申请注销您本人名义注册的账户，并依照平台规则进行注销；</p>
        <p>（3）根据法律法规或监管机构的规定，我们仍可能留存您注销前的相关信息</p>
        <p>（4）注销成功后，账户信息、个人身份证信息、交易记录、会员权益等将无法恢复或提供。</p>
        <div className={styles.emptyLine}></div>
        <p>二、服务内容</p>
        <div className={styles.emptyLine}></div>
        <p>1、本平台是由我们提供的一款互联网平台工具，可应用于Android, IOS, Windows, HarmonyOS等操作系统。</p>
        <p>2、您能享受的服务包括但不限于，（1）由我们根据您提供的个人信息为您提供贷款、担保及其他金融产品的推送、搜索、查询、匹配并根据您选定的金融机构协助您本人向金融机构提出贷款、担保及其他金融产品的申请服务；（2）由我们根据您在本协议项下的授权将您的个人信息共享给第三方机构并由第三方为您提供贷款、担保及其他金融产品的推送、搜索、查询、匹配并根据您选定的金融机构协助您本人向金融机构提出贷款及其他金融产品的申请服务，具体卫付通服务内容以本平台软件程序上展示为准。</p>
        <p>3、为避免歧义，我们提供的卫付通服务仅为您提供贷款和金融产品的推荐和信息服务或者第三方机构的推荐和信息服务（并由第三方机构为您提供贷款和金融产品的推荐和信息服务），我们和卫付通不是贷款和金融产品的服务提供方，我们和卫付通不向您就贷款和金融产品提供任何形式的承诺和保证，具体贷款和金融产品由您和产品提供方另行签署服务协议予以约定。</p>
        <div className={styles.emptyLine}></div>
        <p>三、信息提供、授权和隐私保护</p>
        <div className={styles.emptyLine}></div>
        <p>1、关于我们如何收集、保护和使用个人信息的具体规则，请您仔细阅读<span className={styles.bold}>《授权/隐私政策》。</span></p>
        <p>2、您同意我们为了向您提供卫付通服务的需要，将您的个人信息（包括姓名、手机号码、身份证号码以及贷款申请信息）共享给金融机构或者第三方机构，以便于金融机构或者第三方机构为您提供贷款、担保及其他金融产品的推送、搜索、查询、匹配并根据您选定的金融机构协助您本人向金融机构提出贷款、担保及其他金融产品的申请服务，具体个人信息处理规则由金融机构或者第三方机构与您另行约定。</p>
        <p>3、您在访问、使用卫付通或申请使用卫付通服务时，必须提供本人真实的个人信息，且您应该根据实际变动情况及时更新个人信息。保护用户隐私是我们的重点原则，我们通过各种技术手段和强化内部管理等办法提供隐私保护服务功能，充分保护您的个人信息安全。</p>
        <p className={styles.bold}>卫付通不负责审核您提供的个人信息的真实性、准确性或完整性，因信息不真实、不准确或不完整而引起的任何问题及其后果，由您自行承担，且您应保证我们免受由此而产生的任何损害或责任。若我们发现您提供的个人信息是虚假、不准确或不完整的，我们有权自行决定终止向您提供服务，并拒绝您使用本平台的部分或全部功能，由此产生的损失，由您自行承担。</p>
        <p>4、您已明确授权，为提供服务、履行协议、解决争议、保障交易安全等目的，我们对您提供的、我们自行收集的及通过第三方收集的您的个人信息、您申请服务时的相关信息、您在使用服务时储存在卫付通的非公开内容以及您的其他个人资料（以下简称“个人资料”）享有留存、整理加工、使用、共享和披露的权利，具体方式包括但不限于：</p>
        <p>（1）出于为您提供服务的需要在本网站公示您的个人资料；</p>
        <p>（2）由人工或自动程序对您的个人资料进行获取、评估、整理、存储；</p>
        <p>（3）使用您的个人资料以改进本网站的设计和推广；</p>
        <p>（4）使用您提供的联系方式与您联络并向您传递有关服务和管理方面的信息；</p>
        <p>（5）对您的个人资料进行分析整合并向为您提供服务的合作方提供为完成服务必要的信息。</p>
        <p>（6）在您违反与我们或我们的其他用户签订的协议时，披露您的个人资料及违约事实，将您的违约信息写入黑名单并与必要的合作方共享数据，以供我们及合作方审核、追索之用。</p>
        <p>（7）其他必要的使用及披露您个人资料的情形。</p>
        <p>5、为更好地为您提供服务，您理解并同意在您注册成为卫付通会员时，卫付通有权调取并保存您的手机位置信息、手机设备信息、通讯录、通话记录以及短信（包括但不限于短信内容、短信时间、发送对象等），并保证仅将前述信息作为卫付通为您提供服务使用。另外，为使最终提供借款服务的合作方能够更准确地评估您的资信，卫付通会将该等调取的信息发送给该合作方，用于您本次借款资信评估。</p>
        <p>6、若您曾经已经登陆过卫付通，且已经授权卫付通完成了相应的信息获取事宜，当您再次登陆卫付通，并选择相关产品时，您授权卫付通自动将之前授权获取的您的信息推送给为您提供服务的合作方。</p>
        <p>7、我们保证采用行业惯例以保护您的资料，但您理解，鉴于技术限制，我们无法确保用户的个人信息完全不被泄露。</p>
        <p>8、我们不会向与您无关的第三方恶意出售或免费提供您的个人资料，但下列情况除外：</p>
        <p>（1）事先获得您的明确授权；</p>
        <p>（2）按照相关司法机构或政府主管部门的要求；</p>
        <p>（3）以维护我们合法权益之目的；</p>
        <p>（4）维护社会公众利益；</p>
        <p>（5）为了确保卫付通业务和系统的完整与操作。</p>
        <p>（6）符合其他合法要求。</p>
        <div className={styles.emptyLine}></div>
        <p>四、使用准则</p>
        <div className={styles.emptyLine}></div>
        <p>1、您在使用卫付通服务过程中，必须遵循<span className={styles.bold}>《互联网信息服务管理办法》及《网络信息内容生态治理规定》等法律法规以及相关标准关于网络信息内容安全的要求，不得输入、利用本网站输出或传播以下违法不良信息：</span></p>
        <p>（1）反对宪法所确定的基本原则的；</p>
        <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
        <p>（3）损害国家荣誉和利益的；</p>
        <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
        <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
        <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
        <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的、欺诈性的或以其它令人反感的讯息、数据、信息、文本、音乐、声音、照片、图形、代码或其它材料；</p>
        <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
        <p>（9）其他违反宪法和法律、行政法规或规章制度的；</p>
        <p>（10）可能侵犯他人的专利、商标、商业秘密、版权或其它知识产权或专有权利的内容；</p>
        <p>（11）假冒任何人或实体或以其它方式歪曲您与任何人或实体之关联性的内容；</p>
        <p>（12）未经请求而擅自提供的促销信息、政治活动、广告或意见征集；</p>
        <p>（13）任何第三方的私人信息，包括但不限于地址、电话号码、电子邮件地址、身份证号以及信用卡卡号；</p>
        <p>（14）病毒、不可靠数据或其它有害的、破坏性的或危害性的文件；</p>
        <p>（15）与内容所在的互动区域的话题不相关的内容；</p>
        <p>（16）依我们的自行判断，足以令人反感的内容，或者限制或妨碍他人使用或享受互动区域或卫付通的内容，或者可能使我们或我们关联方或其他用户遭致任何类型损害或责任的内容；</p>
        <p>（17）包含法律或行政法规禁止内容的其他内容。</p>
        <p>2、您需要严格遵守<span className={styles.bold}>《网络安全法》及《数据安全法》等法律法规以及相关标准的要求，不得对本服务以及支持本服务正常运行的系统、网络、模型以及其他组件等进行干扰、破坏或攻击，不得从事以下危害本服务安全的活动：</span> </p>
        <p>(1)未经允许，进入互联网信息网络或者使用互联网信息网络资源；</p>
        <p>(2)未经允许，对互联网信息网络功能进行删除、修改或者增加；</p>
        <p>(3)未经允许，对进入互联网信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；</p>
        <p>(4)故意制作、传播计算机或手机病毒等破坏性程序；</p>
        <p>(5)其他危害互联网信息网络安全的行为。</p>
        <p>3、我们保留在任何时候为任何理由而不经通知地过滤、移除、筛查或编辑本网站上发布或存储的任何内容的权利，您须自行负责备份和替换在本网站发布或存储的任何内容，成本和费用自理。</p>
        <p>4、您须对自己在使用卫付通服务过程中的行为承担法律责任。</p>
        <p>5、如您的操作影响系统总体稳定性或完整性，我们将暂停或终止您的操作，直到相关问题得到解决。</p>
        <p>6、<span className={styles.bold}>我们的服务仅只面向成年人及非学生人群。如果您未满18周岁或者为学生，请立即停止使用您的账户及卫付通服务。</span></p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>五、免责声明</p>
        <div className={styles.emptyLine}></div>
        <p>1、本网站是一个开放平台，用户将文章或照片等个人资料上传到互联网上，有可能会被其他组织或个人复制、转载、擅改或做其它非法用途，用户必须充分意识此类风险的存在。作为网络服务的提供者，我们对用户在任何论坛、个人主页或其它互动区域提供的任何陈述、声明或内容均不承担责任。您明确同意使用卫付通服务所存在的风险或产生的一切后果将完全由您自身承担，我们对上述风险或后果不承担任何责任。</p>
        <p>2、您违反本协议、违反道德或法律的，侵犯他人权利（包括但不限于知识产权）的，我们不承担任何责任。同时，我们对任何第三方通过卫付通发送服务或包含在服务中的任何内容不承担责任。</p>
        <p>3、对您、其他用户或任何第三方发布、存储或上传的任何内容或由该等内容导致的任何损失或损害，我们不承担责任。</p>
        <p>4、对任何第三方通过卫付通可能对您造成的任何错误、中伤、诽谤、诬蔑、不作为、谬误、淫秽、色情或亵渎，我们不承担责任。</p>
        <p>5、对黑客行为、计算机或手机病毒、或因您保管疏忽致使帐号、密码被他人非法使用、盗用、篡改的或丢失，或由于与本网站链接的其它网站所造成您个人资料的泄露，或您因其他非卫付通原因造成的损失，我们不承担责任。如您发现任何非法使用用户帐号或安全漏洞的情况，请立即与我们联系。</p>
        <p>6、因任何非卫付通原因造成的网络服务中断或其他缺陷，我们不承担任何责任。</p>
        <p>7、我们不保证服务一定能满足您的要求；不保证服务不会中断，也不保证服务的及时性、安全性、准确性。</p>
        <p>8、任何情况下，因使用卫付通而引起或与使用卫付通有关的而产生的由我们负担的责任总额，无论是基于合同、保证、侵权、产品责任、严格责任或其它理论，均不得超过您因访问或使用本网站而向我们支付的当次服务费用总额。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>六、服务变更、中断或终止</p>
        <div className={styles.emptyLine}></div>
        <p>1、如因升级的需要而需暂停网络服务、或调整服务内容，我们将尽可能在网站上进行通告。由于用户未能及时浏览通告而造成的损失，我们不承担任何责任。</p>
        <p>2、您明确同意，我们保留根据实际情况随时调整卫付通提供的服务内容、种类和形式，或自行决定授权第三方向您提供原本我们提供的服务。因业务调整给您或其他用户造成的损失，我们不承担任何责任。同时，我们保留随时变更、中断或终止卫付通全部或部分服务的权利。</p>
        <p>3、发生下列任何一种情形，我们有权单方面中断或终止向您提供服务而无需通知您，且无需对您或第三方承担任何责任：</p>
        <p>（1）您提供的个人资料不真实；</p>
        <p>（2）您违反本服务条款；</p>
        <p>（3）未经我们书面同意，将卫付通平台用于商业目的。</p>
        <p>4、您可随时取消卫付通服务。自您取消服务之日起，我们不再向您承担任何形式的责任。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>七、风险提示</p>
        <div className={styles.emptyLine}></div>
        <p>1、将尽力促使服务的正确、持续、及时和安全。</p>
        <p>2、平台中展示的任何内容仅供参考，除明确声明外，不构成对任何人的投资、法律、会计或税务建议，不保证切合您的个别情况，请您独立谨慎地判断业务风险。我们将尽力保证所提供内容的来源可靠，并要求相关内容提供方保证上述内容的真实性、准确性及完整性，您不应对上述内容作不适当的依赖。任何我们转载的内容仅代表其原作者的观点和态度，我们对此不作任何判断。</p>
        <p className={styles.bold}>3、在适用法律允许的范围内，我们有权随时自行决定暂停、终止服务，或对部分用户暂停、终止服务；我们将尽最大努力保证将上述暂停、终止操作对您尚在使用期间服务的影响降到最低或不产生影响。在适用法律允许的范围内，我们有权随时自行决定修改服务，用户有权自主决定是否继续使用修改后的服务。在适用法律允许的范围内，我们有权随时自行决定更换提供服务的主体，用户有权自主决定是否使用新主体提供的服务。</p>
        <p className={styles.bold}>4、我们可能会在服务中集成由第三方提供的产品及服务、链接至第三方和/或展示第三方的标记或内容，我们提供该等集成、链接、展示的目的仅在于向您提供方便，我们对此不作任何保证，亦不代表对该等第三方、其产品及服务的任何推荐、支持或授权，您应当自行甄别并自担风险。您在使用上述第三方的任何产品和服务时，应当了解并接受该等第三方的条款和规则。</p>
        <p className={styles.bold}>5、因第三方提供相关服务的问题或瑕疵产生的责任由该第三方承担，我们不承担该等责任，但我们可为用户维权提供必要的协助。</p>
        <p className={styles.bold}>6、因用户自身的原因导致的任何损失或责任，由用户自行负责，我们不承担责任。不承担责任的情形包括但不限于：</p>
        <p className={styles.bold}>(1)用户未按照本协议或平台不时公布的任何规则进行操作导致的任何损失或责任；</p>
        <p className={styles.bold}>(2)因用户使用的银行卡的原因导致的损失或责任，包括用户使用未经认证的银行卡或使用非用户本人的银行卡或使用信用卡，用户的银行卡被冻结、挂失等导致的任何损失或责任；</p>
        <p className={styles.bold}>(3)用户向我们发送的指令信息不明确、或存在歧义、不完整等导致的任何损失或责任；</p>
        <p className={styles.bold}>(4)用户账户内余额不足导致的任何损失或责任；</p>
        <p className={styles.bold}>(5)其他因用户原因导致的任何损失或责任。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>八、知识产权及其它权利</p>
        <div className={styles.emptyLine}></div>
        <p>1、用户可以充分利用卫付通平台共享信息。您可以在卫付通发布从卫付通个人主页或其他网站复制的图片和信息等内容，但这些内容必须属于公共领域或者您拥有以上述使用方式使用该等内容的权利，且您有权对该等内容作出本条款下之授权、同意、认可或承诺。</p>
        <p>2、对您在卫付通发布或以其它方式传播的内容，您作如下声明和保证：</p>
        <p>（1）对于该等内容，您具有所有权或使用权；</p>
        <p>（2）该等内容是合法的、真实的、准确的、非误导性的；</p>
        <p>（3）使用和发布此等内容或以其它方式传播此等内容不违反本服务条款，也不侵犯任何人或实体的任何权利或造成对任何人或实体的伤害。</p>
        <p>3、未经相关内容权利人的事先书面同意，您不得擅自复制、传播在卫付通的该等内容，或将其用于任何商业目的，所有这些资料或资料的任何部分仅可作为个人或非商业用途而保存在某台计算机或其他电子设备内。否则，我们及/或权利人将追究您的法律责任。</p>
        <p>4、您在卫付通发布或传播的自有内容或具有使用权的内容，您特此同意如下：</p>
        <p>（1）授予我们使用、复制、修改、改编、翻译、传播、发表此等内容，从此等内容创建派生作品，以及在全世界范围内通过任何媒介（现在已知的或今后发明的）公开展示和表演此等内容的权利；</p>
        <p>（2）授予我们及其关联方和再许可人一项权利，可依他们的选择而使用用户有关此等内容而提交的名称；</p>
        <p>（3）授予我们在第三方侵犯您在卫付通的权益、或您发布在卫付通的内容情况下，依法追究其责任的权利（但这并非我们的义务）；</p>
        <p>5、您在卫付通公开发布或传播的内容、图片等为非保密信息，我们没有义务将此等信息作为您的保密信息对待。在不限制前述规定的前提下，我们保留以适当的方式使用内容的权利，包括但不限于删除、编辑、更改、不予采纳或拒绝发布。我们无义务就您提交的内容而向您付款。一旦内容已在卫付通发布，我们也不保证向您提供对在卫付通发布内容进行编辑、删除或作其它修改的机会。</p>
        <p>6、如有权利人发现您在卫付通发表的内容侵犯其权利，并依相关法律、行政法规的规定向我们发出书面通知的，我们有权在不事先通知您的情况下自行移除相关内容，并依法保留相关数据。您同意不因该种移除行为向我们主张任何赔偿，如我们因此遭受任何损失，您应赔偿我们的损失（包括但不限于赔偿各种费用及律师费）。</p>
        <p>7、您认为您发布的内容并未侵犯其他方的权利，您可以向我们以书面方式说明被移除内容不侵犯其他方权利的书面通知，该书面通知应包含如下内容：您详细的身份证明、住址、联系方式、您认为被移除内容不侵犯其他方权利的证明、被移除内容在卫付通上的位置以及书面通知内容的真实性声明。我们收到该书面通知后，有权决定是否恢复被移除内容。</p>
        <p>8、您特此同意，如果您提供的书面通知的陈述失实，您将承担由此造成的全部法律责任，如我们因此遭受任何损失，您应向赔偿我们的损失（包括但不限于赔偿各种费用及律师费）。</p>
        <p className={styles.bold}>9、如果您认为本服务涉及侵害您知识产权或其他权利的，或者您发现任何违法、虚假信息以及违反本协议的使用行为，或者您对我们的服务有任何意见与建议，可以通过产品界面-查看头像-点击“联系我们”按钮进行提交，或通过我们公开的联系邮箱及联系地址向我们进行如实反馈。我们将对您的意见高度重视并依法采取处理措施。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>九、通知与送达</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>1、我们对于您的通知及任何其他的协议、告示或其他关于您使用服务的通知，您同意我们可通过平台公告、站内信、电子邮件、手机短信、无线通讯装置等电子方式或邮寄等物理方式进行，该等通知于发送之日视为已送达收件人；如以邮寄方式向您发出通知的，则在该等通知按照您在平台留存的联系地址交邮后的第三个自然日即视为送达。因不可归责于我们的原因（包括但不限于电子邮件地址、手机号码、联系地址等不准确或无效、信息传输故障等）导致您未在前述通知视为送达之日收到该等通知的，我们不承担任何责任。</p>
        <p className={styles.bold}>2、对于您与我们的任何纠纷，您同意并授权司法机关在全部诉讼阶段和程序中按照上述方式向您送达任何法律文书。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>十、法律适用及法律管辖</p>
        <div className={styles.emptyLine}></div>
        <p>1、本协议由您与我们共同签订，适用于您在平台的一切合法活动。我们通过平台发布的公示的各类业务规则及指引，应视为本协议不可分割的一部分，与本协议条款具有同等法律效力。</p>
        <p>2、如就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，任何一方均可向厦门乐真网络科技有限公司住所地人民法院提起诉讼。</p>
        <div className={styles.emptyLine}></div>
        <p className={styles.bold}>十一、其他</p>
        <div className={styles.emptyLine}></div>
        <p>1、您使用本服务的行为若有任何违反国家法律法规或侵犯任何第三方的合法权益的情形时，我们有权直接删除该等违反规定之信息，并可以暂停或终止向您提供服务。</p>
        <p>2、若您利用卫付通服务从事任何违法或侵权行为，由您自行承担全部责任，因此给我们或任何第三方造成任何损失，您应负责全额赔偿，并使我们免受由此产生的任何损害。</p>
        <p>3、您同意我们通过重要页面的公告、通告、电子邮件以及常规信件的形式向您传送与卫付通有关的任何通知和通告。</p>
        <p>4、如您有任何有关与卫付通服务的个人信息保护相关投诉，请您与我们联系，我们将在接到投诉之日起15日内进行答复。</p>
        <p>5、本协议之效力、解释、执行均适用中华人民共和国法律。</p>
        <p>6、若非卫付通更新本协议，您再确认同意、签署本协议后，其效力将及于您此时及未来登陆卫付通时所有操作。</p>
        <p>7、您在本协议项下对我们的授权将视为对我们及我们之关联公司的授权。我们及我们关联公司均可凭借您的授权及本协议约定执行相关操作。</p>
        <p>8、本协议中的标题仅为方便而设，不影响对于条款本身的解释。</p>
        <p>9、如本协议中任何条款无论何种原因被认定为完全或部分无效或不具有执行力，不应影响本协议其他条款及本协议的效力。</p>
      </>
    )
  }

  return (
    <div className={classNames(styles.registerAgreement, isShowHeader && styles.isShowHeader)}>
      {
        isShowHeader && <Header title="用户注册服务协议" />
      }
      {
        youqianlaiRegister()
      }
    </div>
  )
}

export default RegisterAgreement